import { Cookies } from 'react-cookie';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

class CookieStorage {
    constructor() {
        this.cookies = new Cookies();
        this.isNative = Capacitor.getPlatform() !== 'web';
    }

    async setValue(key, value, options = {}) {
        if (this.isNative) {
            await Preferences.set({ key, value: String(value) });
        } else {
            this.cookies.set(key, value, {
                path: '/',
                secure: true,
                sameSite: 'strict',
                ...options,
            });
        }
    }

    async getValue(key) {
        if (this.isNative) {
            const { value } = await Preferences.get({ key });
            return value || null;
        } else {
            return this.cookies.get(key) || null;
        }
    }

    async removeValue(key) {
        if (this.isNative) {
            await Preferences.remove({ key });
        } else {
            this.cookies.remove(key, { path: '/' });
        }
    }
}

export default CookieStorage;
